var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": { maxWidth: _vm.getMaxWidth, minWidth: _vm.getMinWidth },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show_subscription_modal,
        callback: function($$v) {
          _vm.show_subscription_modal = $$v
        },
        expression: "show_subscription_modal"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_subscription_modal = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("registration_cancellation")) +
                    "\n\t\t\t"
                )
              ])
            ],
            1
          ),
          _vm.user
            ? _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("div", { staticClass: "col-12" }, [
                    _c("p", [
                      _c("strong", [_vm._v(_vm._s(_vm.$t("user")) + ": ")]),
                      _vm._v(
                        _vm._s(
                          _vm.user.full_name + " (" + _vm.user.email + ")"
                        ) + "\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "q-field",
                        { attrs: { count: 256 } },
                        [
                          _c("q-input", {
                            ref: "observation",
                            attrs: {
                              "float-label": _vm.$t("motive"),
                              error: _vm.$v.observation.$error,
                              disable: _vm.blockUserActions
                            },
                            on: { input: _vm.$v.observation.$touch },
                            model: {
                              value: _vm.observation,
                              callback: function($$v) {
                                _vm.observation = $$v
                              },
                              expression: "observation"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col-12 q-mb-md" }, [
                    _c("div", { staticClass: "row gutter-sm" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("p", { staticClass: "caption" }, [
                            _vm._v(_vm._s(_vm.$t("evidences")))
                          ]),
                          _c("uploader", {
                            attrs: {
                              multiple: true,
                              cropper: false,
                              disable: _vm.blockUserActions
                            },
                            on: { fileUploaded: _vm.fileUploaded }
                          }),
                          _vm.attachments.length
                            ? _c(
                                "q-list",
                                {
                                  staticClass: "q-mt-md",
                                  attrs: {
                                    dense: "",
                                    bordered: "",
                                    padding: "",
                                    separator: ""
                                  }
                                },
                                _vm._l(_vm.attachments, function(
                                  attachment,
                                  index
                                ) {
                                  return _c(
                                    "q-item",
                                    { key: index },
                                    [
                                      _c("q-item-side", {
                                        attrs: {
                                          icon: "fas fa-check",
                                          color: "positive"
                                        }
                                      }),
                                      _c("q-item-main", [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "text-black",
                                            attrs: {
                                              href: attachment,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$truncateLink(attachment)
                                                )
                                            )
                                          ]
                                        )
                                      ]),
                                      _c(
                                        "q-item-side",
                                        { attrs: { right: "" } },
                                        [
                                          _c(
                                            "q-btn",
                                            {
                                              attrs: {
                                                round: "",
                                                flat: "",
                                                color: "negative",
                                                icon: "fas fa-trash"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeFile(
                                                    attachment
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("q-tooltip", [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(_vm.$t("remove")) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm justify-end q-mt-lg" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-3",
                          class: _vm.getOrder("cancel")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "tertiary",
                              label: _vm.$t("cancel"),
                              icon: "fas fa-chevron-left"
                            },
                            on: {
                              click: function($event) {
                                _vm.show_subscription_modal = false
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-3",
                          class: _vm.getOrder("save")
                        },
                        [
                          _c(
                            "q-btn",
                            {
                              staticClass: "full-width",
                              attrs: {
                                color: "secondary",
                                label: _vm.$t("save"),
                                icon: "far fa-save",
                                disable: _vm.blockUserActions
                              },
                              on: {
                                click: function($event) {
                                  return _vm.askForCancelation()
                                }
                              }
                            },
                            [
                              !_vm.allow_enrollment_cancellation
                                ? _c("q-tooltip", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "enrollment_cancelation_limit_date_expired"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm.logs.length
                    ? _c("q-table", {
                        staticClass: "q-mt-md",
                        attrs: {
                          data: _vm.logs,
                          columns: _vm.columns,
                          "row-key": "id",
                          "no-data-label": _vm.$t("no_data_avaliable"),
                          "no-results-label": _vm.$t("no_results_found"),
                          "loading-label": _vm.$t("loading_data"),
                          "rows-per-page-label": _vm.$t("items_per_page"),
                          "rows-per-page-options": [0],
                          "binary-state-sort": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "header",
                              fn: function(props) {
                                return _c(
                                  "q-tr",
                                  { attrs: { props: props } },
                                  _vm._l(props.cols, function(col) {
                                    return _c(
                                      "q-th",
                                      {
                                        key: col.name,
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t" +
                                            _vm._s(_vm.$t(col.label)) +
                                            "\n\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                )
                              }
                            },
                            {
                              key: "body",
                              fn: function(props) {
                                return _c(
                                  "q-tr",
                                  {},
                                  [
                                    _c(
                                      "q-td",
                                      {
                                        key: "author_full_name",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t" +
                                            _vm._s(props.row.author_full_name) +
                                            "\n\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "author_email",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t" +
                                            _vm._s(props.row.author_email) +
                                            "\n\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "status",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t" +
                                            _vm._s(_vm.$t(props.row.status)) +
                                            "\n\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "observation",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t" +
                                            _vm._s(props.row.observation) +
                                            "\n\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "created_date",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t" +
                                            _vm._s(props.row.created_date) +
                                            "\n\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "actions",
                                        attrs: {
                                          "auto-width": "",
                                          props: props
                                        }
                                      },
                                      [
                                        _c(
                                          "q-btn",
                                          {
                                            attrs: {
                                              round: "",
                                              flat: "",
                                              icon: "fas fa-exclamation",
                                              color: "secondary",
                                              disabled: !props.row.attachments
                                                .length
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.openEvidence(
                                                  props.row
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("q-tooltip", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t("show_evidences")
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t"
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          505270887
                        )
                      })
                    : _vm._e(),
                  _c(
                    "q-dialog",
                    {
                      model: {
                        value: _vm.attachments_view,
                        callback: function($$v) {
                          _vm.attachments_view = $$v
                        },
                        expression: "attachments_view"
                      }
                    },
                    [
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v(_vm._s(_vm.$t("evidences")))
                      ]),
                      _c(
                        "div",
                        { attrs: { slot: "body" }, slot: "body" },
                        [
                          _c(
                            "q-list",
                            {
                              staticClass: "q-mt-md",
                              attrs: {
                                dense: "",
                                bordered: "",
                                padding: "",
                                separator: ""
                              }
                            },
                            _vm._l(_vm.attachments_to_view, function(
                              attachment,
                              index
                            ) {
                              return _c(
                                "q-item",
                                { key: index },
                                [
                                  _c("q-item-side", {
                                    attrs: {
                                      icon: "fas fa-check",
                                      color: "positive"
                                    }
                                  }),
                                  _c("q-item-main", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "text-black",
                                        attrs: {
                                          href: attachment,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$truncateLink(attachment)
                                            )
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }